const Introducer: React.FC = () => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const anchor = document.querySelector("#projects");
    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-3 border-b-2 border-gray">
      <div className="m-5 flex h-full flex-col justify-evenly sm:flex-row sm:gap-7">
        <img
          className="aspect-square h-auto w-48 max-w-full self-center rounded-full "
          src="/res/portrait.jpg"
          alt="portraitPhoto"
        />
        <div className="mb-6 sm:flex sm:flex-col sm:justify-center">
          <h1 className="mb-3">Hi,</h1>
          <h1 className="mb-3"> I'm Jun! </h1>
          <h2 className="mb-3 font-light text-white">
            Computer Science and Philosophy Student
          </h2>
          <h2 className="mb-3 font-light text-white">Software Developer</h2>
        </div>
      </div>

      <div className="absolute bottom-0 m-4 flex w-full justify-center">
        <a
          className="flex items-center justify-center"
          href="#projects"
          onClick={handleClick}
        >
          <img
            src="/res/svgs/downArrow.svg"
            className="w-1/12 transition duration-300 hover:scale-150"
          />
        </a>
      </div>
    </div>
  );
};

export default Introducer;
